import styled from 'styled-components';

export const DropzoneBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  padding: 10px;
  height: 150px;
  border: 1px dashed #000000de;
  border-radius: 8px;
`;
